<template>
  <div>
    <GmapMap
      id="map"
      v-if="content"
      :center="{lat:50, lng:10}"
      :zoom="11"
      :options="options"
      map-type-id="roadmap"
      ref="map"
    >
      <gmap-custom-marker
        @click.native="showInfo(i)"
        v-for="(m,i) in content.markers"
        :key="i"
        :marker="m"
      >
        <div class="marker-content">
          <img :src="m.img">
        </div>
        <div v-if="isActive(i)" class="bloc-description">
          <fai class="icon" icon="times" @click.native="closeInfo(i)"></fai>
          <p class="description">{{m.description}}</p>
          <a
            class="map-link"
            :href="`https://www.google.com/maps/search/?api=1&query=${m.lat},${m.lng}&query_place_id=${m.placeId}`"
          >
            <p class="adress">{{m.address}}</p>
          </a>
        </div>
      </gmap-custom-marker>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import api from "@/api";
import { mapOptions } from "@/variables";
export default {
  components: {
    "gmap-custom-marker": GmapCustomMarker
  },
  props: {
    content: null
  },
  data() {
    return {
      options: mapOptions,
      google: null,
      activeMarker: null
    };
  },
  computed: {},
  mounted() {
    this.$gmapApiPromiseLazy().then(res => {
      this.google = res;
    });
  },
  methods: {
    isActive(i) {
      return i === this.activeMarker;
    },
    closeInfo(i) {
      this.activeMarker = null;
      this.centerMap();
    },
    centerMap() {
      var bounds = new this.google.maps.LatLngBounds();
      for (var i = 0; i < this.content.markers.length; i++) {
        let m = this.content.markers[i];
        bounds.extend({
          lat: parseFloat(m.lat),
          lng: parseFloat(m.lng)
        });
      }
      if (this.content.markers.length > 1) {
        this.$refs.map.$mapPromise.then(map => {
          map.fitBounds(bounds);
        });
      } else {
        this.$refs.map.$mapPromise.then(map => {
          let m = this.content.markers[0];
          map.panTo({ lat: parseFloat(m.lat), lng: parseFloat(m.lng) });
        });
      }
    },
    showInfo(i) {
      if (this.activeMarker == i) {
        this.activeMarker = null;
      } else {
        this.activeMarker = i;
        let m = this.content.markers[i];
        this.$refs.map.$mapPromise.then(map => {
          map.panTo({ lat: parseFloat(m.lat), lng: parseFloat(m.lng) });
          map.setZoom(15);
        });
      }
    }
  },
  watch: {
    google: function(val) {
      this.centerMap();
    }
  }
};
</script>

<style lang="scss">
$imgWidth: 150;
$descriptionWidth: 230;
.marker-content {
  text-align: center;
  img {
    width: #{$imgWidth}px;
    margin-bottom: 10px;
  }
  .icon {
    font-size: 39px;
    color: $primary;
  }
}
.bloc-description {
  position: absolute;
  width: #{$descriptionWidth}px;
  height: #{$descriptionWidth}px;
  background-color: #fff;
  margin-left: calc(#{-$descriptionWidth/2 + $imgWidth / 2}px);
  top: calc(100% + 20px);
  border-radius: 15px;
  cursor: pointer;
  .adress {
    font-size: 12px;
    padding: 1em;
  }
  .description {
    margin-top: 10px;
    padding: 0 1em;
  }
  .icon {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 20px;
    color: $primary;
    cursor: pointer;
  }
  .map-link {
    margin: 15px 0;
    margin-bottom: 0;
    background-color: $primary;
    border-radius: 5px;

    color: white;
    display: block;
    position: absolute;
    bottom: 0;
  }
}
#map {
  height: 500px;
}
</style>